import React from "react";
import { APP_VERSION } from "@/version";
import { useBranding } from "@/lib/branding";

export default function Footer({ dark }) {
  const b = useBranding();
  const org = b.university_name ? `${b.university_name} Alumni Association` : "Alumni Association";
  return (
    <footer
      data-testid="app-footer"
      className={`w-full border-t px-5 py-4 text-center text-xs ${dark ? "border-white/10 text-white/50" : "border-border text-muted-foreground"}`}
    >
      <span data-testid="footer-copyright">© {new Date().getFullYear()} {org}</span>
      <span className="mx-2 opacity-40">·</span>
      <span data-testid="footer-version">v{APP_VERSION}</span>
    </footer>
  );
}
